import React from 'react';
import Screen from '../../components/layout/Screen';
import ScrollableContainer from '../../components/ScrollableContainer';
import { ICONS } from '../../common/icons/icons';
import { Link, useNavigate } from 'react-router-dom';
import { AuthService } from '../../common/API/AuthService';
import { useAuth } from '../../common/context/AuthProvider';
import { Button } from '@/components/ui/button';

const SettingsScreen = () => {
  const navigate = useNavigate();
  const { logout, userData } = useAuth();
  const onLogout = () => {
    logout();
  };

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Settings',
          titleClassName: 'text-white',
        },
      }}
    >
      <ScrollableContainer>
        <section className='mb-10 flex items-center flex-col justify-center mt-5'>
          <div className='rounded-full w-[90px] h-[90px] bg-secondary-foreground/20 flex items-center justify-center'>
            <span className='text-secondary text-3xl uppercase'>
              {userData?.data?.name?.[0] ?? userData?.data?.email?.[0]}
            </span>
          </div>
          <h1 className='text-white text-2xl mt-2'>{userData?.data?.name}</h1>
          <p className='text-neutral-400'>{userData?.data?.email}</p>
        </section>
        <section className='bg-card rounded-lg mb-5'>
          <Link
            to='profile'
            className='relative text-sm flex items-center p-3 border-b border-neutral-800 last:border-none last:rounded-b-lg rounded-t-lg'
          >
            <span className='w-6 h-6 rounded-lg flex items-center justify-center bg-gradient-to-r from-gray-500 to-gray-400 text-xs'>
              {ICONS.userConfig}
            </span>
            <h3 className='ml-2 text-white'>Personal information</h3>
            <span className='absolute right-3 text-2xl text-neutral-500'>{ICONS.chevronRight}</span>
          </Link>
          <Link to='password' className='relative text-sm flex items-center p-3 border-b last:border-none  rounded-lg'>
            <span className='w-6 h-6 rounded-lg flex items-center justify-center bg-gradient-to-r from-gray-500 to-gray-400 text-xs'>
              {ICONS.userConfig}
            </span>
            <h3 className='ml-2 text-white'>Change password</h3>
            <span className='absolute right-3 text-2xl text-neutral-500'>{ICONS.chevronRight}</span>
          </Link>
        </section>
        <Button className='bg-red-500 w-full' onClick={onLogout}>
          Sign out
        </Button>
      </ScrollableContainer>
    </Screen>
  );
};

export default SettingsScreen;
